import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common');
  const currentLang = i18n.language?.startsWith('ar') ? 'ar' : 'en';

  const toggleLang = () => {
    const next = currentLang === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(next);
  };

  return (
    <button
      onClick={toggleLang}
      className="flex items-center gap-1 px-2 py-1 md:px-3 md:py-1.5 rounded-full bg-background-100 border border-background-200 hover:border-background-300 transition-colors cursor-pointer text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap"
      title={t('nav.language')}
    >
      <i className="ri-global-line text-xs md:text-sm"></i>
      <span>{currentLang === 'ar' ? 'EN' : 'AR'}</span>
    </button>
  );
}